import { useState } from 'react'
import { ContentModal } from 'components/organisms/modals/content-modal'
import TermsContent, { Term } from 'containers/common/TermsContent'

interface Props {
	readonly open: boolean
	readonly setOpen: (open: boolean) => void
}

export function TermsAndConditionsModal({ open, setOpen }: Props) {
	return (
		<ContentModal open={open} setOpen={setOpen} isModal={true} title="Terms and Conditions" size="2xl">
			<div>
				<TermsContent term={Term.TermsOfService} />
			</div>
		</ContentModal>
	)
}

export function PrivacyPolicyModal({ open, setOpen }: Props) {
	return (
		<ContentModal open={open} setOpen={setOpen} isModal={true} title="Privacy Policy" size="2xl">
			<div>
				<TermsContent term={Term.PrivacyPolicy} />
			</div>
		</ContentModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export type TermsAndConditionsModalManagedProps = Record<string, unknown>

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'terms-and-conditions': TermsAndConditionsModalManagedProps
	}
}

export function ManagedTermsAndConditionsModal({
	onClose,
}: TermsAndConditionsModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<TermsAndConditionsModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
		/>
	)
}
